// src/components/Navbar.js
import React, { useState, useEffect, useCallback } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import "../index.css";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const closeMenu = useCallback(() => setOpen(false), []);
  const toggleMenu = useCallback(() => setOpen((v) => !v), []);

  // Ferme le menu à chaque changement de page
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  // Empêche le scroll derrière le menu quand il est ouvert (mobile)
  useEffect(() => {
    document.body.classList.toggle("nav-open", open);
    return () => document.body.classList.remove("nav-open");
  }, [open]);

  // Ferme au clavier (ESC)
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape") closeMenu();
    };
    if (open) window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open, closeMenu]);

  // Mailto "Vérifier ma disponibilité" (style premium, conversion)
  const buildAvailabilityMailto = () => {
    const to = "contact@hlbk.fr";
    const subject = "Vérifier ma disponibilité";
    const body = [
      "Bonjour Maxime,",
      "",
      "Je souhaiterais vérifier votre disponibilité pour :",
      "",
      "• Prestation :",
      "• Date :",
      "• Lieu :",
      "• Horaires approximatifs :",
      "• Nom(s) :",
      "• Téléphone :",
      "",
      "Merci !",
      "— Envoyé depuis hlbk.fr",
    ].join("\n");

    return `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  return (
    <nav className="navbar nav-centered" role="navigation" aria-label="Navigation principale">
      {/* Logo centré (dimensions fixées pour éviter le CLS) */}
      <div className="navbar-logo-wrap">
        <Link to="/" className="navbar-logo" aria-label="Accueil" onClick={closeMenu}>
          <img
            src="/images/logo.png"
            alt="HLBK"
            width="120"
            height="120"
            decoding="async"
            fetchPriority="high"
          />
        </Link>
      </div>

      {/* Burger (mobile) */}
      <button
        className={`nav-burger ${open ? "is-open" : ""}`}
        aria-label={open ? "Fermer le menu" : "Ouvrir le menu"}
        aria-expanded={open}
        aria-controls="navmenu"
        onClick={toggleMenu}
      >
        <span className="burger-bar" />
        <span className="burger-bar" />
        <span className="burger-bar" />
      </button>

      {/* Menu */}
      <div id="navmenu" className={`navbar-menu ${open ? "open" : ""}`}>
        {/* 1) Sections principales (conversion) */}
        <NavLink to="/galerie" onClick={closeMenu} className={({ isActive }) => (isActive ? "active" : undefined)}>
          Galerie
        </NavLink>
        <NavLink to="/services" onClick={closeMenu} className={({ isActive }) => (isActive ? "active" : undefined)}>
          Prestations
        </NavLink>
        <NavLink to="/about" onClick={closeMenu} className={({ isActive }) => (isActive ? "active" : undefined)}>
          À propos
        </NavLink>
        <NavLink to="/contact" onClick={closeMenu} className={({ isActive }) => (isActive ? "active" : undefined)}>
          Contact
        </NavLink>

        {/* 2) CTA premium (tu peux le styliser en "btn" dans index.css) */}
        <a
          href={buildAvailabilityMailto()}
          className="nav-cta"
          onClick={closeMenu}
        >
          Vérifier ma disponibilité
        </a>

        {/* 3) Accès clients plus discret */}
        <div className="nav-sep" aria-hidden="true" />
        <NavLink
          to="/acces-clients"
          onClick={closeMenu}
          className={({ isActive }) => (isActive ? "active nav-muted" : "nav-muted")}
        >
          Accès clients
        </NavLink>
      </div>

      {/* Voile clicable derrière le menu (mobile) */}
      {open && <div className="nav-backdrop" onClick={closeMenu} aria-hidden="true" />}
    </nav>
  );
}